import {
  OTHERGOODS_INVENTORY_FAILED,
  OTHERGOODS_INVENTORY_REQUEST,
  OTHERGOODS_INVENTORY_SUCCESS,
} from "app/redux/actions/Inventory/otherGoods/constants.js";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const otherGoodsInventoryReducer = function (
  state = INIT_STATE,
  action
) {

  switch (action?.type) {
    case OTHERGOODS_INVENTORY_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case OTHERGOODS_INVENTORY_SUCCESS:
      console.log("payload => ", action?.payload?.data);
      return {
        loading: false,
        data: action?.payload?.data,

        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case OTHERGOODS_INVENTORY_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
